import React, { useState } from "react";
import { getColorHex } from "../blockTypeConstants";
import "../../DealApproval.scss";
import CustomSelect from "../../../../components/CustomSelect/CustomSelect";
import { isValidMeaningfulData } from "../helpers";

const CardGridForm = ({ itemIndex, blockItem, iconColorOptions = [], iconTypeOptions = [], onUpdateBlockItem, onDeleteBlockItem }) => {
    const [blockTitleError, setBlockTitleError] = useState("");
    const defaultIconColor = iconColorOptions[0]?.optionValue || "";
    const defaultIconType = iconTypeOptions[0]?.optionValue || "";
    const colorHex = getColorHex(blockItem.iconColor || defaultIconColor, iconColorOptions);

    const handleBlockTitleChange = (e) => {
        const value = e.target.value;
        onUpdateBlockItem(itemIndex, "blockTitle", value);
        
        const trimmedValue = value.trim();
        let error = "";
        
        if (trimmedValue) {
            if (trimmedValue.length < 3) {
                error = "Card title must be at least 3 characters.";
            } else if (!isValidMeaningfulData(trimmedValue)) {
                error = "Please enter a valid and meaningful data.";
            }
        }
        
        setBlockTitleError(error);
    };

    return (
        <>
            <div className="metric-header-row">
                <label>Card Block Title <span className="required-mark">*</span></label>
                <button
                    type="button"
                    className="card-delete-text-btn"
                    onClick={() => onDeleteBlockItem(itemIndex)}
                >
                    Delete
                </button>
            </div>
            <input
                type="text"
                placeholder="Enter Title for this card block..."
                value={blockItem.blockTitle || ""}
                maxLength={300}
                onChange={handleBlockTitleChange}
                className={blockTitleError ? "input-error" : ""}
            />
            <div className="error-counter-row">
                {blockTitleError ? <p className="form-error-text">{blockTitleError}</p> : <span className="error-placeholder" />}
                <span className="char-counter-text">{(blockItem.blockTitle || "").length}/300</span>
            </div>
            {(blockItem.blockTitle || "").length >= 300 && <p className="char-limit-note">Max 300 characters reached</p>}
            <div className="card-icon-color-group">
                <label>Icon color (Default color is black)</label>
                <div className="bullet-color-select-wrap">
                    <span className="bullet-color-swatch" style={{ background: colorHex }} />
                    <CustomSelect
                        className="bullet-color-select"
                        options={iconColorOptions.map((opt) => ({ value: opt.optionValue, label: opt.optionLabel }))}
                        value={blockItem.iconColor || defaultIconColor}
                        onChange={(value) => onUpdateBlockItem(itemIndex, "iconColor", value)}
                    />
                </div>
            </div>
            <div className="card-icon-value-row">
                <div className="card-icon-field">
                    <label>Icon <span className="required-mark">*</span></label>
                    <CustomSelect
                        options={iconTypeOptions.map((opt) => ({ value: opt.optionValue, label: opt.optionLabel }))}
                        value={blockItem.iconType || defaultIconType}
                        onChange={(value) => onUpdateBlockItem(itemIndex, "iconType", value)}
                    />
                </div>
                <div className="card-value-field">
                    <label>Value <span className="required-mark">*</span></label>
                    <input
                        type="number"
                        placeholder="Enter the value..."
                        value={blockItem.value || ""}
                        maxLength={15}
                        onWheel={(e) => e.currentTarget.blur()}
                        onChange={(e) => onUpdateBlockItem(itemIndex, "value", e.target.value.replace(/\D/g, ""))}
                        onKeyDown={(e) => {
                            if (["e", "E", "+", "-", "."].includes(e.key)) e.preventDefault();
                        }}
                    />
                    <span className="char-counter-text">{(blockItem.value || "").toString().length}/15</span>
                    {(blockItem.value || "").toString().length >= 15 && <p className="char-limit-note">Max 15 digits reached</p>}
                </div>
            </div>
        </>
    );
};

export default CardGridForm;
